import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

import rateLimit, {getStandardTimeout} from "utils/rate_limit";
import {createChangeTimeWrapper} from "utils/ensure_fresh_update";

function doSave(requestor, organisationId, projectId, data, changeTime) {
  return requestor
    .patch(
      `${basePath}/organisation/${organisationId}/project/${projectId}`,
      data,
      {withCredentials: true},
    )
    .then(response => ({
      ...createChangeTimeWrapper(changeTime),
      ...response.data,
    }));
}

const save = rateLimit(doSave, getStandardTimeout());

export default function updateProject(requestor) {
  const action = createReduxPromiseAction(
    ActionTypes.PROJECT_UPDATE,
    (organisationId, projectId, data, changeTime) => {
      if (!data.last_edited) {
        throw new Error("data must contain a last_edited key");
      }
      return save(requestor, organisationId, projectId, data, changeTime);
    },
    (organisationId, projectId, data, changeTime) => ({
      ...createChangeTimeWrapper(changeTime),
      ...data,
    }),
  );

  return action;
}
